import { put, call, select, delay } from 'redux-saga/effects';
import {
  FETCH_TASK,

} from './actionTypes';

import * as services from './services';
import * as actions from './actions';

import { message } from 'antd';

export default {

  *[FETCH_TASK]({ payload }) {

    const params = { ...payload };
    const conversations = yield call(services.fetchTask, params);


    // const orders = conversations.data.map(conv => conv.order)
    // console.log(3333, conversations)
    // yield put(convsFetched(conversations.data, queryType));
    // let nextActiveConv;
    // if (orderId) {
    //   nextActiveConv = conversations.data.find(
    //     (conv) => conv.order._id === orderId
    //   );
    //   if (!nextActiveConv) return message.info('工单不存在');
    // } else if (convId) {
    //   nextActiveConv = conversations.data.find((conv) => conv._id === convId);
    // }
    // if (nextActiveConv) yield put(navToConversation(nextActiveConv._id));
  },

};
